const defaultLayout = "default";
const cimpressDefaultSelection = "cimpressDefaultSelection";
const cimpressPreferredSelection = "cimpressPreferredSelection";
const packingLayout = "upload_personalization_configuration_packaging";
const stock = "stock";
const stockDefaultPdfConfiguration = "stock_configuration_default_pdf";
const stockDefaultPdf = "stock_default_pdf";
const personalization = "personalization";
const upload = "upload_without_configuration";
const upload_configuration = "upload_configuration";
const personalization_configuration = "personalization_configuration";

const upload_personalization_configuration =
  "upload_personalization_configuration";
const upload_fullpage_configuration = "upload_fullpage_configuration";
const personalization_fullpage_configuration =
  "personalization_fullpage_configuration";
const upload_personalization_fullpage_configuration =
  "upload_personalization_fullpage_configuration";
const upload_my_account = "upload_my_account";

const image_editor = "image_editor";

const layouts = {
  [defaultLayout]: {
    name: "LayoutMatrix" //"LayoutMatrix",
  },
  [cimpressDefaultSelection]: {
    name: "LayoutAdminDefaultSelection"
  },
  [cimpressPreferredSelection]: {
    name: "LayoutAdminPreferredSelection"
  },
  [packingLayout]: {
    name: "LayoutPacking"
  },
  [stock]: {
    name: "LayoutStock"
  },
  [stockDefaultPdf]: {
    name: "LayoutStockDefaultPdf"
  },
  [stockDefaultPdfConfiguration]: {
    name: "LayoutStockDefaultPdfConfiguration"
  },
  [personalization]: {
    name: "LayoutPersonalization"
  },
  [upload]: {
    name: "LayoutUpload"
  },
  [upload_configuration]: {
    name: "LayoutUploadConfiguration"
  },
  [personalization_configuration]: {
    name: "LayoutPersonalizationConfiguration"
  },
  [upload_personalization_configuration]: {
    name: "LayoutUploadPersonalizationConfiguration"
  },
  [upload_fullpage_configuration]: {
    name: "LayoutUploadFullPageConfiguration"
  },
  [personalization_fullpage_configuration]: {
    name: "LayoutPersonalizationFullPageConfiguration"
  },
  [upload_personalization_fullpage_configuration]: {
    name: "LayoutUploadPersonalizationFullPageConfiguration"
  },
  [image_editor]: {
    name: "LayoutImageEditor"
  },
  [upload_my_account]: {
    name: "LayoutUploadMyAccount"
  }

  /*default: "LayoutMatrix",
  upload_fullpage_configuration: "LayoutMatrix",
  configuration: "LayoutConfiguration",*/
};

export const getLayoutName = layoutType => {
  if (layouts[layoutType]) {
    return "app" + layouts[layoutType].name;
  }
  return "app" + layouts[defaultLayout].name;
};

export const getMyAccountLayoutName = layoutType => {
  return "app" + layouts[upload_my_account].name;
};
